import ajax from '../http/ajax'

export const saveAddress = data => {
    return ajax.get('saveAddress', data)
}

export const delAddressById = data => {
    return ajax.post('delAddressById', data)
}

export const getAddressInfoById = data => {
    return ajax.post('getAddressInfoById', data)
}
